import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { catchError, Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AnalyticsService } from './analytics.service';
import { UtilsService } from './utils.service';
import { CartService } from './cart.service';
@Injectable({
  providedIn: 'root'
})
export class CartDetailsService {

  cartInfo$: any;
  sub: Subscription = new Subscription();
  constructor(public http: HttpClient, private analyticsService: AnalyticsService, public utils: UtilsService, public service: CartService, @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const encryptedCart: any = localStorage.getItem('cart');
      this.cartInfo$ = this.utils.decryptarrayText(encryptedCart);
    }

  }
  onPinCodeChange(data: any) {
    let controller;
    const userId = localStorage.getItem('userId')
    controller = userId ? 'GetCartDetailsOnPinCodeChange' : 'GetAnonymousCartDetailsOnPinCodeChange'
    return this.http.post(`${this.utils.apiUrl}Cart/${controller}`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  checkout() {
    const encryptedCart: any = localStorage.getItem('cart');
    const decryptedCart = this.utils.decryptarrayText(encryptedCart);
    this.cartInfo$ = decryptedCart;
    if (this.cartInfo$) {

      this.cartInfo$ = JSON.parse(this.cartInfo$)
    }
    let products: any = []
    if (this.cartInfo$ && this.cartInfo$.length > 0) {
      this.cartInfo$.forEach((element: any) => {
        products.push(
          {
            inventoryGuId: element.inventoryGuId,
            quantity: element.quantity,
            pincode: Number(this.utils.getUserPicode())
          }
        )
      });
    }
    let data = {
      updateCartRequestList: products
    }
    this.triggerCartUpdate()
    return this.http.post(`${this.utils.apiUrl}Cart/UpdateCart`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  triggerCartUpdate() {
    if (isPlatformBrowser(this.platformId)) {
      let cartInfo$: any = [];
      let totalQuantity = 0;
      const encryptedbuyNow: any = localStorage.getItem('buyNow');
      const decryptedbuyNow = this.utils.decryptarrayText(encryptedbuyNow);
      let isBuyNow: any = decryptedbuyNow;
      if (!isBuyNow) {
        this.sub.add(this.service.cartData$.subscribe(
          (data: any) => {
            if (data)
              cartInfo$ = data
          }));
      }
      else {
        this.sub.add(this.service.buyNowData$.subscribe(
          (data: any) => {
            cartInfo$ = data ? data : []
          }))
      }
      if (cartInfo$ && cartInfo$.length) {
        totalQuantity = cartInfo$.reduce(
          (accumulator: any, currentValue: any) => accumulator + currentValue.quantity,
          0
        );
        const data = {
          eventName: "Cart Updated",
          eventData: {
            'Total Price': parseFloat((Math.round((this.analyticsService.getOrderTotal()) * 100) / 100).toFixed(2)),
            'Total Items': cartInfo$.length,
            'line items': cartInfo$.map((data: any) => {
              return {
                'Product Name': data.productName,
                'Product Price': data.productMRP,
                'Product Image': data.productImageFileName,
                'total quantity': data.quantity,
                'total price': parseFloat((Math.round((this.analyticsService.getItemTotal(data)) * 100) / 100).toFixed(2)),
                'price before tax': parseFloat((Math.round((data.basePrice) * 100) / 100).toFixed(2)),
                'tax': parseFloat((Math.round(((data.basePrice / 100) * data.taxPercent) * 100) / 100).toFixed(2)),
              }
            }),
            'Total Quantity': totalQuantity || 0
          }
        };
        this.analyticsService.trackData(data);
      }
      else {
        const data = {
          eventName: "Cart Updated",
          eventData: {
            'Total Price': 0,
            'Total Items': 0,
            'line items': [],
            'Total Quantity': 0
          }
        };
        this.analyticsService.trackData(data);
      }
    }
  }
  pinCodeChange(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.utils.showLoading();

      const encryptedCart: any = localStorage.getItem('cart');


      const decryptedCart = this.utils.decryptarrayText(encryptedCart);

      let cartInfo$ = JSON.parse(decryptedCart);

      if (cartInfo$ && cartInfo$.length) {
        const products = cartInfo$.map((element: any) => ({ productGuId: element.productGuId }));

        const data = {
          pinCode: this.utils.getUserPicode(),
          productGuIdRequests: products,
        };

        this.sub.add(
          this.onPinCodeChange(data)?.subscribe({
            next: (response: any) => {
              this.utils.hideLoading()
              if (response.success) {
                this.service.processCartItems(
                  cartInfo$,
                  response,
                  (updateCart: any) => {
                    if (updateCart && this.utils.getUser()) {
                      this.sub.add(this.checkout().subscribe(() => { }));
                    }
                  },
                  (_emptyCart: any) => {
                    this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                    this.service.clearInfo();
                    if (this.utils.getUser()) {
                      this.sub.add(this.checkout().subscribe(() => { }));
                    }
                  },
                  true,
                  false
                );
              } else {
                this.utils.hideLoading();
                this.utils.openSnackBar(response.message, 'error-toster');
              }
            },
            error: (err) => {
              this.utils.hideLoading();
              console.error('Pin code change error:', err);
              this.utils.openSnackBar('Failed to update pin code.', 'error-toster');
            },
            complete: () => {
              this.utils.hideLoading();
            },
          })
        );
      } else {
        this.utils.hideLoading();
      }
    }
  }


  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }
}
